import store from "@/store";

async function getCalculateVolumeAndDensityMixin(
  items,
  totalHuCountAux,
  totalWeight
) {
  let dimensionsAux = [];
  for (let item in items) {
    if (items[item].dimensions != null && items[item].dimensions != "") {
      dimensionsAux.push(items[item].dimensions);
    }
  }
  if (
    totalHuCountAux.length === 0 ||
    dimensionsAux.length === 0 ||
    dimensionsAux.length !== totalHuCountAux.length
  ) {
    return { volume: null, density: null };
  }
  let info = {};
  info.hu_count = totalHuCountAux;
  info.dimensions = dimensionsAux;
  info.total_weight = totalWeight.toString();
  let response = await store.dispatch(
    "totals/getCalculateVolumeAndDensity",
    info
  );
  if (response.status == 200) {
    return response.data;
  } else {
    return {
      volume: null,
      density: null
    };
  }
}

async function getTotalHuCountMixin(totalHuCountAux, items) {
  totalHuCountAux = [];
  for (let item in items) {
    if (items[item].hu_count != null && items[item].hu_count != "") {
      totalHuCountAux.push(items[item].hu_count);
    }
  }
  let info = {};
  info.hu_count = totalHuCountAux;
  let response = await store.dispatch("totals/getTotalHuCount", info);
  if (response.status == 200) {
    let responseAux;
    if (response.data && response.data.includes(" ")) {
      responseAux = response.data.split(" ")[0];
      return {
        responseAux,
        totalHuCountAux
      };
    } else {
      responseAux = response.data;
      return {
        responseAux,
        totalHuCountAux
      };
    }
  }
}

async function getTotalWeightMixin(totalHuCountAux, items) {
  let totalWeightAux = [];
  for (let item in items) {
    if (items[item].weight != null && items[item].weight != "") {
      totalWeightAux.push(items[item].weight);
    }
  }
  let info = {};
  info.hu_count = totalHuCountAux;
  info.weight = totalWeightAux;
  let response = await store.dispatch("totals/getTotalWeight", info);
  if (response.status == 200) {
    return response.data;
  }
}

async function standardizeTotalWieghtMixin(totalWeight) {
  let response;
  if (totalWeight != null && totalWeight != "") {
    response = await store.dispatch(
      "standardize/standardizeWeight",
      totalWeight
    );
    if (response.status == 200) {
      return response.data[0];
    }
  }
}

export {
  getCalculateVolumeAndDensityMixin,
  getTotalHuCountMixin,
  getTotalWeightMixin,
  standardizeTotalWieghtMixin
};
